import React from 'react';
import { createPortal } from 'react-dom';

interface ConfirmModalProps {
  open: boolean;
  title: string;
  message: string | React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmButtonColor?: string;
  confirmButtonHoverColor?: string;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({ 
  open,
  title,
  message,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  onConfirm,
  onCancel,
  confirmButtonColor = 'var(--destructive)',
  confirmButtonHoverColor = 'var(--destructive)'
}) => {
  if (!open) return null;

  // Portal to <body>: ancestors that form stacking contexts (e.g. the sticky
  // side panels) would otherwise trap the overlay and it wouldn't dim the
  // whole page.
  return createPortal(
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: 'var(--card)',
        borderRadius: 12,
        padding: 32,
        maxWidth: 480,
        width: '90%',
        boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)'
      }}>
        <h2 style={{ margin: 0, marginBottom: 16, fontSize: 24, fontWeight: 700, color: 'var(--foreground)' }}>
          {title}
        </h2>
        <div style={{ margin: 0, marginBottom: 24, fontSize: 16, color: 'var(--muted-foreground)', lineHeight: 1.6 }}>
          {message}
        </div>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
          <button
            onClick={onCancel}
            style={{
              background: 'var(--border)',
              color: 'var(--foreground)',
              border: 'none',
              borderRadius: 6,
              padding: '10px 20px',
              fontWeight: 600,
              cursor: 'pointer',
              fontSize: 14
            }}
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            style={{
              background: confirmButtonColor,
              color: 'var(--card)',
              border: 'none',
              borderRadius: 6,
              padding: '10px 20px',
              fontWeight: 600,
              cursor: 'pointer',
              fontSize: 14
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default ConfirmModal;
